import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';

import { faPlus, faEdit, faKey, faTrash } from '@fortawesome/pro-regular-svg-icons'

import APICtx from '#api'
import { TplWSidebar as Tpl } from '#Template'
import Search, { SearchText } from '#Search'
import List, { ListItem } from '#List'
import Fab from '#Fab'

const Group = ({ _id, handleListRefresh }) => {
	const api = useContext(APICtx)
	const [ data, setData ] = useState({})

	const handleDelete = () => {
		api.dialogConfirm({
			text: 'Sei sicuro di voler elimnare il gruppo "'+data?.address+'"?',
			onConfirm: () => api.call('groups/del', { _id }).then(handleListRefresh),
		})
	}

	const handleRefresh = () => api.call('groups/get', { _id }).then(setData)
	useEffect(() => {
		handleRefresh()
	}, [ _id ])

	const actions = [
		{ tooltip:'Modifica', icon:faEdit, linkTo:"edit/"+_id },
		{ tooltip:'Permessi', icon:faKey, linkTo:"acl/"+_id },
		{ tooltip:'Elimina', icon:faTrash, onClick:handleDelete },
	]

	return (
		<ListItem
			avatar={data.address}
			label={data.address}
			sublabel={data.displayName}
			actions={actions}
		/>
	)
}

const GroupListPage = () => {
	const api = useContext(APICtx)
	const [ groups, setGroups ] = useState([])
	const [ searchTxt, setSearchTxt ] = useState('')
	const { domId } = useParams()

	const handleRefresh = () => api.call('groups/list', { domId, searchTxt }).then(setGroups)
	useEffect(() => {
		handleRefresh()
	}, [ domId, searchTxt ])

	return (
		<Tpl title="Gruppi">
			<Search>
				<SearchText name="search" label="Cerca gruppo" onChange={setSearchTxt} />
			</Search>
			<List>
				{ groups && groups.map(_id => <Group key={_id} _id={_id} handleListRefresh={handleRefresh} /> )}
			</List>
			<Fab label="Crea gruppo" icon={faPlus} linkTo="edit" />
		</Tpl>
	)
}
export default GroupListPage